import { render, staticRenderFns } from "./ContributionForm.vue?vue&type=template&id=8f007304"
import script from "./ContributionForm.vue?vue&type=script&lang=js"
export * from "./ContributionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports